<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          Views Last 30 Days
        </b-card-title>
      </div>
      <!--/ title and subtitle -->
    </b-card-header>

    <b-card-body>
      <b-row class="mb-2">
        <b-col md="4">
          <b-form-group class="mb-0">
            Start Date
            <flat-pickr
              v-model="from"
              :config="datePickerConfig"
              class="form-control mt-50"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group class="mb-0">
            End Date
            <flat-pickr
              v-model="to"
              :config="datePickerConfig"
              class="form-control mt-50"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" class="d-flex align-items-end">
          <b-button
            size="sm"
            variant="primary"
            class="mr-50"
            :disabled="loading"
            @click="fetchData"
          >
            Apply
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            :disabled="loading"
            @click="resetLocalFilter"
          >
            Reset
          </b-button>
        </b-col>
      </b-row>
      <b-spinner
        v-if="loading"
        class="align-middle mr-1 my-2"
        variant="secondary"
      ></b-spinner>
      <vue-apex-charts
        type="line"
        height="400"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BBadge,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BSpinner,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import flatPickr from 'vue-flatpickr-component'
import moment from '@/libs/moment'

export default {
  components: {
    VueApexCharts,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BSpinner,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    flatPickr,
  },
  data() {
    return {
      loading: false,
      from: moment()
        .subtract(29, 'days')
        .format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        allowInput: true,
      },
      series: [
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: true,
          },
        },
        markers: {
          strokeWidth: 7,
          strokeOpacity: 1,
          strokeColors: [$themeColors.light],
          colors: [$themeColors.warning],
        },
        colors: [$themeColors.warning],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        tooltip: {
          custom(data) {
            return `${'<div class="px-1 py-50"><span>'}${
              data.series[data.seriesIndex][data.dataPointIndex]
            }</span></div>`
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          // opposite: isRtl,
        },
      },
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    normalizeDateInput(value) {
      if (!value) return ''
      if (value instanceof Date) {
        return moment(value).format('YYYY-MM-DD')
      }
      const strictIso = moment(String(value), 'YYYY-MM-DD', true)
      if (strictIso.isValid()) {
        return strictIso.format('YYYY-MM-DD')
      }
      const loose = moment(value)
      return loose.isValid() ? loose.format('YYYY-MM-DD') : ''
    },
    resetLocalFilter() {
      this.from = moment()
        .subtract(29, 'days')
        .format('YYYY-MM-DD')
      this.to = moment().format('YYYY-MM-DD')
      this.fetchData()
    },
    fetchData() {
      const start = this.normalizeDateInput(this.from)
      const end = this.normalizeDateInput(this.to)
      if (!start || !end) {
        this.$notif('Warning', 'Format tanggal tidak valid.', 'warning')
        return
      }
      if (moment(start).isAfter(moment(end))) {
        this.$notif(
          'Warning',
          'Start Date tidak boleh lebih besar dari End Date.',
          'warning'
        )
        return
      }

      this.from = start
      this.to = end
      this.loading = true
      this.$http
        .get('/visitor-log/last30', {
          params: {
            start,
            end,
          },
        })
        .then(({ data }) => {
          const reversedData = [...data].reverse()
          const newData = reversedData.map(item => item.count)
          const newAxis = reversedData.map(item => item.DATE)

          this.chartOptions = {
            chart: {
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: true,
              },
            },
            markers: {
              strokeWidth: 7,
              strokeOpacity: 1,
              strokeColors: [$themeColors.light],
              colors: [$themeColors.warning],
            },
            colors: [$themeColors.warning],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
            },
            grid: {
              xaxis: {
                lines: {
                  show: true,
                },
              },
            },
            tooltip: {
              custom(data) {
                return `${'<div class="px-1 py-50"><span>'}${
                  data.series[data.seriesIndex][data.dataPointIndex]
                }</span></div>`
              },
            },
            xaxis: {
              categories: newAxis,
            },
            yaxis: {
              // opposite: isRtl,
            },
          }

          this.series = [
            {
              data: newData,
            },
          ]
        })
        .catch(({ data }) =>
          this.$notif('Error', `${data?.message || ''}`, 'error')
        )
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
